import { render } from "./LandingBlockHowItWorks.vue?vue&type=template&id=9e8a2558&scoped=true&lang=pug"
import script from "./LandingBlockHowItWorks.vue?vue&type=script&lang=js"
export * from "./LandingBlockHowItWorks.vue?vue&type=script&lang=js"

import "./LandingBlockHowItWorks.vue?vue&type=style&index=0&id=9e8a2558&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e8a2558"]])

export default __exports__